
import React from 'react'
import {Input} from "antd";
import seven_img from "../../../../images/config/authorizationProgress/17.png"
import eight_img from "../../../../images/config/authorizationProgress/8.png"
import nine_img from "../../../../images/config/authorizationProgress/9.png"
import ten_img from "../../../../images/config/authorizationProgress/10.png"
import eleven_img from "../../../../images/config/authorizationProgress/11.png"
import Message from "../../../common/message";
import CorpApi from "../../../public/corp_api";
class AuthorizationModification extends React.Component {
    constructor(props){
        super(props);
        this.secretChange=this.secretChange.bind(this)
        this.state={
            secret:''
        }
    }
    componentDidMount() {
        CorpApi.getGainSubmitClientRelationPassword((data)=>{
            this.setState({
                secret:data.secret
            })
        },()=>{
            Message.error('提交错误，请稍后再试')
        })
    }

    //secrect输入事件
    secretChange(e){
        this.setState({
            secret:e.target.value
        })
    }
    checkData(){
        if((!this.state.secret) || this.state.secret.length==0){
            Message.warning("请输入Secret", null, null, true);
        }
    }
    /**
     * 整合改组件数据并返回
     */
    getData() {
        let data = {
            secret:this.state.secret
        };
        return data
    }

    render() {
        return (
            <div className={'authorizationModification'}>
                <div>
                    <div>（1）切换到【客户联系】- 【客户】，点击【API】展开，Secret 点击【查看】-【发送】，发送成功后，管理员会在企业微信中将会收到如下提醒，复制Secret后，填写到下方输入框中</div>
                    <div className={'authorization_Input_Change'}>
                        <span>*Secret：</span>
                        <span><Input size='smallz' placeholder="请输入Secret" value={this.state.secret} onChange={this.secretChange}/></span>
                    </div>
                    <div><img src={seven_img}/></div>
                    <div><img src={eight_img}/></div>
                    <div><img src={nine_img}/></div>
                    <div>（2）填写Secret后，选择【可调用应用】，点击【设置】，如果在此之前已经进行过应用配置，点击【修改】</div>
                    <div><img src={ten_img}/></div>
                    <div>（3）勾选之前创建的【紫鲲】，点击【确定】即可</div>
                    <div><img src={eleven_img}/></div>
                </div>
            </div>
        )
    }
}

export default AuthorizationModification
